import React from 'react';
import { ErrorState } from '../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { ColumnChartLoading } from '../../../CommonComponents/OPL/charts/ColumnChart/ColumnChart.loading';
import { useProjectedIncomeQuery } from '../../api/useProjectedIncomeQuery';
import { usePeriod } from '../../hooks/usePeriod';
import { useRouteParams } from '../../hooks/useRouteParams';
import { CHART_HEIGHT } from './ProjectedIncomeChart.meta';
import { ProjectedIncomeChartContent } from './ProjectedIncomeChartContent/ProjectedIncomeChartContent';

export const ProjectedIncomeChart = () => {
  const { accountId, groupId } = useRouteParams();

  const period = usePeriod();

  const { isFetching, isError, refetch, data } = useProjectedIncomeQuery({
    period: period.value,
    startDate: period.dates[0],
    endDate: period.dates[1],
    accountId,
    groupId,
  });

  if (isFetching) {
    return <ColumnChartLoading chartHeight={CHART_HEIGHT} />;
  }

  if (isError) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" height="100%">
        <ErrorState onAction={refetch} />
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  return <ProjectedIncomeChartContent data={data} />;
};
